import axiosInstance from "./axiosInstance";

const communityBannedUsersService = {
  async list(page = 1, limit = 25, requestOpts = {}) {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", String(limit));
    const response = await axiosInstance.get(
      `admin/users/community-banned-app-users?${params.toString()}`,
      { signal: requestOpts.signal }
    );
    return response.data;
  },
};

export default communityBannedUsersService;
